import React from "react";

export const Header = () => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <div className="section-title text-center">
                  <h2>Откройте двери к внутреннему спокойствию</h2>
                </div>
                <div className="hero-description-alt">
                  <p>
                    Профессиональная психологическая помощь для достижения гармонии в жизни.
                    <br />
                    <strong>Начните свой путь к счастью и самопознанию уже сегодня!</strong>
                  </p>
                </div>
                <a
                  href="#contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Записаться на консультацию
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
